<template>
  <div class="">
    <Header></Header>
    <div class="page-container">
      <div class="page-wrapper">
        <div class="page-back-wrapper">
          <div class="page-back" @click="handleBack">
            <img src="@/assets/img/back.png" alt="" class="page-back-img" />
            <span>返回</span>
          </div>
          <div class="page-title">{{ exerciseData.title }}</div>
        </div>

        <div class="content-container">
          <div class="content-left-container">
            <div class="content-left-wrapper">
              <div
                class="content-left-title"
                v-if="intoExerciseType !== 'viewExercise'"
              >
                <img src="@/assets/img/clock2.png" alt="" class="clock-img" />
                <span>{{ examTime }}</span>
              </div>
              <div class="exercise-wrapper">
                <div class="exercise-title">
                  <span v-if="activeMode == 'radio'">单选题</span>
                  <span v-if="activeMode == 'checkbox'">多选题</span>
                  <span v-if="activeMode == 'justify'">判断题</span>
                  <div class="exercise-left-line"></div>
                </div>
                <div class="exercise-content">
                  <div class="exercise-content-title">
                    {{ form.questionTitle }}
                  </div>
                  <div
                    v-if="activeMode == 'radio'"
                    class="exercise-options-wrapper"
                  >
                    <div
                      v-if="
                        activePaper == 'partError' ||
                        activePaper == 'partAnalysis' ||
                        activePaper == 'totalError' ||
                        activePaper == 'totalAnalysis'
                      "
                    >
                      <div v-if="form.isRight == 1">
                        <div
                          v-for="(item, key) in form.options"
                          :key="key"
                          class="exercise-content-item"
                        >
                          <div
                            v-if="item.value == form.questionAnswer"
                            class="answerShow-container"
                          >
                            <div
                              class="answerShow-border-right answerShow-radio"
                            >
                              <i class="el-icon-check answerShow-item-icon"></i>
                            </div>
                            <div class="answerShow-item-label-right">
                              <span class="answer-value-wrap">{{
                                item.value
                              }}</span
                              >{{ item.label }}
                            </div>
                          </div>
                          <div v-else class="answerShow-container">
                            <div class="answerShow-border answerShow-radio">
                              <i class="answerShow-item-icon"></i>
                            </div>
                            <div class="answerShow-item-label">
                              <span class="answer-value-wrap">{{
                                item.value
                              }}</span
                              >{{ item.label }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else>
                        <div
                          v-for="(item, key) in form.options"
                          :key="key"
                          class="exercise-content-item"
                        >
                          <div
                            v-if="item.value == form.questionAnswer"
                            class="answerShow-container"
                          >
                            <div
                              class="answerShow-border-right answerShow-radio"
                            >
                              <i class="el-icon-check answerShow-item-icon"></i>
                            </div>
                            <div class="answerShow-item-label-right">
                              <span class="answer-value-wrap">{{
                                item.value
                              }}</span
                              >{{ item.label }}
                            </div>
                          </div>
                          <div
                            v-else-if="item.value == form.userAnswer"
                            class="answerShow-container"
                          >
                            <div
                              class="answerShow-border-error answerShow-radio"
                            >
                              <i class="el-icon-check answerShow-item-icon"></i>
                            </div>
                            <div class="answerShow-item-label-error">
                              <span class="answer-value-wrap">{{
                                item.value
                              }}</span
                              >{{ item.label }}
                            </div>
                          </div>
                          <div v-else class="answerShow-container">
                            <div class="answerShow-border answerShow-radio">
                              <i class="answerShow-item-icon"></i>
                            </div>
                            <div class="answerShow-item-label">
                              <span class="answer-value-wrap">{{
                                item.value
                              }}</span
                              >{{ item.label }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      <el-radio-group
                        v-model="form.answerVal"
                        @change="answerQuestion"
                      >
                        <div
                          v-for="(item, key) in form.options"
                          :key="key"
                          class="exercise-content-item"
                        >
                          <el-radio :label="item.value"
                            ><span class="answer-value-wrap">{{
                              item.value
                            }}</span
                            ><span class="answer-lable-wrap">{{
                              item.label
                            }}</span></el-radio
                          >
                        </div>
                      </el-radio-group>
                    </div>
                  </div>
                  <div
                    v-if="activeMode == 'checkbox'"
                    class="exercise-options-wrapper"
                  >
                    <div
                      v-if="
                        activePaper == 'partError' ||
                        activePaper == 'partAnalysis' ||
                        activePaper == 'totalError' ||
                        activePaper == 'totalAnalysis'
                      "
                    >
                      <div v-if="form.isRight == 1">
                        <div
                          v-for="(item, key) in form.options"
                          :key="key"
                          class="exercise-content-item"
                        >
                          <div
                            v-if="form.answerVal.indexOf(item.value) >= 0"
                            class="answerShow-container"
                          >
                            <div class="answerShow-border-right">
                              <i class="el-icon-check answerShow-item-icon"></i>
                            </div>
                            <div class="answerShow-item-label-right">
                              <span class="answer-value-wrap">{{
                                item.value
                              }}</span
                              >{{ item.label }}
                            </div>
                          </div>
                          <div v-else class="answerShow-container">
                            <div class="answerShow-border">
                              <i class="answerShow-item-icon"></i>
                            </div>
                            <div class="answerShow-item-label">
                              <span class="answer-value-wrap">{{
                                item.value
                              }}</span
                              >{{ item.label }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else>
                        <div
                          v-for="(item, key) in form.options"
                          :key="key"
                          class="exercise-content-item"
                        >
                          <div
                            v-if="form.questionAnswer.indexOf(item.value) >= 0"
                            class="answerShow-container"
                          >
                            <div class="answerShow-border-right">
                              <i class="el-icon-check answerShow-item-icon"></i>
                            </div>
                            <div class="answerShow-item-label-right">
                              <span class="answer-value-wrap">{{
                                item.value
                              }}</span
                              >{{ item.label }}
                            </div>
                          </div>
                          <div
                            v-else-if="form.answerVal.indexOf(item.value) >= 0"
                            class="answerShow-container"
                          >
                            <div class="answerShow-border-error">
                              <i class="el-icon-check answerShow-item-icon"></i>
                            </div>
                            <div class="answerShow-item-label-error">
                              <span class="answer-value-wrap">{{
                                item.value
                              }}</span
                              >{{ item.label }}
                            </div>
                          </div>
                          <div v-else class="answerShow-container">
                            <div class="answerShow-border">
                              <i class="answerShow-item-icon"></i>
                            </div>
                            <div class="answerShow-item-label">
                              <span class="answer-value-wrap">{{
                                item.value
                              }}</span
                              >{{ item.label }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      <el-checkbox-group
                        v-model="form.answerVal"
                        @change="answerQuestion"
                      >
                        <div
                          v-for="(item, key) in form.options"
                          :key="key"
                          class="exercise-content-item"
                        >
                          <el-checkbox :label="item.value"
                            ><span class="answer-value-wrap">{{
                              item.value
                            }}</span
                            ><span class="answer-lable-wrap">{{
                              item.label
                            }}</span></el-checkbox
                          >
                        </div>
                      </el-checkbox-group>
                    </div>
                  </div>
                  <div
                    v-if="activeMode == 'justify'"
                    class="exercise-options-wrapper"
                  >
                    <div
                      v-if="
                        activePaper == 'partError' ||
                        activePaper == 'partAnalysis' ||
                        activePaper == 'totalError' ||
                        activePaper == 'totalAnalysis'
                      "
                    >
                      <div v-if="form.isRight == 1">
                        <div
                          v-for="(item, key) in form.options"
                          :key="key"
                          class="exercise-content-item"
                        >
                          <div
                            v-if="item.value == form.questionAnswer"
                            class="answerShow-container"
                          >
                            <div
                              class="answerShow-border-right answerShow-radio"
                            >
                              <i class="el-icon-check answerShow-item-icon"></i>
                            </div>
                            <div class="answerShow-item-label-right">
                              <span class="answer-value-wrap">{{
                                item.value
                              }}</span
                              >{{ item.label }}
                            </div>
                          </div>
                          <div v-else class="answerShow-container">
                            <div class="answerShow-border answerShow-radio">
                              <i class="answerShow-item-icon"></i>
                            </div>
                            <div class="answerShow-item-label">
                              <span class="answer-value-wrap">{{
                                item.value
                              }}</span
                              >{{ item.label }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else>
                        <div
                          v-for="(item, key) in form.options"
                          :key="key"
                          class="exercise-content-item"
                        >
                          <div
                            v-if="item.value == form.questionAnswer"
                            class="answerShow-container"
                          >
                            <div
                              class="answerShow-border-right answerShow-radio"
                            >
                              <i class="el-icon-check answerShow-item-icon"></i>
                            </div>
                            <div class="answerShow-item-label-right">
                              <span class="answer-value-wrap">{{
                                item.value
                              }}</span
                              >{{ item.label }}
                            </div>
                          </div>
                          <div
                            v-else-if="item.value == form.userAnswer"
                            class="answerShow-container"
                          >
                            <div
                              class="answerShow-border-error answerShow-radio"
                            >
                              <i class="el-icon-check answerShow-item-icon"></i>
                            </div>
                            <div class="answerShow-item-label-error">
                              <span class="answer-value-wrap">{{
                                item.value
                              }}</span
                              >{{ item.label }}
                            </div>
                          </div>
                          <div v-else class="answerShow-container">
                            <div class="answerShow-border answerShow-radio">
                              <i class="answerShow-item-icon"></i>
                            </div>
                            <div class="answerShow-item-label">
                              <span class="answer-value-wrap">{{
                                item.value
                              }}</span
                              >{{ item.label }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      <el-radio-group
                        v-model="form.answerVal"
                        @change="answerQuestion"
                      >
                        <div
                          v-for="(item, key) in form.options"
                          :key="key"
                          class="exercise-content-item"
                        >
                          <el-radio :label="item.value"
                            ><span class="answer-value-wrap">{{
                              item.value
                            }}</span
                            ><span class="answer-lable-wrap">{{
                              item.label
                            }}</span></el-radio
                          >
                        </div>
                      </el-radio-group>
                    </div>
                  </div>
                  <!--答案-->
                  <div
                    v-if="correctAnswerShow"
                    class="exercise-answer-container"
                  >
                    <div
                      v-if="form.isRight == 1"
                      class="exercise-answer-isRight-btn"
                    >
                      回答正确
                      <img
                        src="@/assets/img/right.png"
                        alt=""
                        class="right-img"
                      />
                    </div>
                    <div v-else class="exercise-answer-isError-btn">
                      回答错误
                      <i class="el-icon-close exercise-answer-isError-icon"></i>
                    </div>
                    <div class="exercise-answer-content">
                      <div class="exercise-answer-content-left">
                        <div
                          class="exercise-answer-content-right-answer right-answer"
                        >
                          <div
                            class="exercise-answer-content-right-answer-label"
                          >
                            正确答案
                          </div>
                          <div
                            class="exercise-answer-content-right-answer-value"
                          >
                            {{ form.questionAnswer }}
                          </div>
                        </div>
                        <div class="answer-line"></div>
                        <div
                          class="exercise-answer-content-right-answer my-answer"
                        >
                          <div
                            class="exercise-answer-content-right-answer-label"
                          >
                            我的答案
                          </div>
                          <div
                            class="exercise-answer-content-right-answer-value"
                            :style="form.isRight == 0 ? 'color:#EB6C48;' : ''"
                          >
                            {{ form.userAnswer }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="exercise-answer-content-right"
                        @click="viewParse"
                      >
                        <img
                          src="@/assets/img/parse1.png"
                          alt=""
                          class="parse1-img"
                        />
                        查看解析
                      </div>
                    </div>
                    <div v-if="parseShow" class="exercise-parse-container">
                      <div class="exercise-parse-header">
                        <img
                          src="@/assets/img/parse2.png"
                          alt=""
                          class="parse1-img"
                        />
                        解析
                      </div>
                      <div class="exercise-parse-content-wrapper">
                        <div class="exercise-parse-content">
                          {{ form.questionAnalysis }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="exercise-btn-wrapper">
                    <div class="exercise-btn" @click="viewLastQuestion">
                      上一题
                    </div>
                    <div
                      class="exercise-btn"
                      @click="viewNextQuestion"
                      style="margin-left: 20px"
                    >
                      下一题
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="content-right-container">
            <div class="content-right-wrapper">
              <div class="content-left-title">答题卡</div>
              <div class="content-answer-card-item">
                <div class="exercise-title">
                  单选题
                  <div class="exercise-right-line"></div>
                </div>
                <div
                  v-if="
                    activePaper == 'partError' ||
                    activePaper == 'partAnalysis' ||
                    activePaper == 'totalError' ||
                    activePaper == 'totalAnalysis'
                  "
                  class="exercise-answer-option-wrapper"
                >
                  <div
                    v-for="(item, index) in radioArr"
                    :key="index"
                    class="exercise-answer-option"
                    :style="index % 6 == 5 ? 'margin-right:0px;' : ''"
                    @click="handleQuestion(item, index)"
                  >
                    <div v-if="item.userAnswer" class="answer-wrapper">
                      <div v-if="item.isRight == 0" class="answer answer-error">
                        {{ index + 1 }}
                      </div>
                      <div v-else class="answer answer-right">
                        {{ index + 1 }}
                      </div>
                    </div>
                    <div v-else class="answer-wrapper">
                      <div class="answer answer-no">{{ index + 1 }}</div>
                    </div>
                  </div>
                </div>
                <div v-else class="exercise-answer-option-wrapper">
                  <div
                    v-for="(item, index) in radioArr"
                    :key="index"
                    class="exercise-answer-option"
                    :style="index % 6 == 5 ? 'margin-right:0px;' : ''"
                    @click="handleQuestion(item, index)"
                  >
                    <div
                      v-if="activeMode == 'radio' && activeQuestion == index"
                      class="answer-wrapper"
                    >
                      <div class="answer answer3">{{ index + 1 }}</div>
                    </div>
                    <div v-else class="answer-wrapper">
                      <div v-if="item.checked == 0" class="answer answer1">
                        {{ index + 1 }}
                      </div>
                      <div v-if="item.checked == 2" class="answer answer2">
                        {{ index + 1 }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="content-answer-card-item" style="margin-top: 28px">
                <div class="exercise-title">
                  多选题
                  <div class="exercise-right-line"></div>
                </div>
                <div
                  v-if="
                    activePaper == 'partError' ||
                    activePaper == 'partAnalysis' ||
                    activePaper == 'totalError' ||
                    activePaper == 'totalAnalysis'
                  "
                  class="exercise-answer-option-wrapper"
                >
                  <div
                    v-for="(item, index) in checkboxArr"
                    :key="index"
                    class="exercise-answer-option"
                    :style="index % 6 == 5 ? 'margin-right:0px;' : ''"
                    @click="handleQuestion(item, index)"
                  >
                    <div v-if="item.userAnswer" class="answer-wrapper">
                      <div v-if="item.isRight == 0" class="answer answer-error">
                        {{ index + 1 }}
                      </div>
                      <div v-else class="answer answer-right">
                        {{ index + 1 }}
                      </div>
                    </div>
                    <div v-else class="answer-wrapper">
                      <div class="answer answer-no">{{ index + 1 }}</div>
                    </div>
                  </div>
                </div>
                <div v-else class="exercise-answer-option-wrapper">
                  <div
                    v-for="(item, index) in checkboxArr"
                    :key="index"
                    class="exercise-answer-option"
                    :style="index % 6 == 5 ? 'margin-right:0px;' : ''"
                    @click="handleQuestion(item, index)"
                  >
                    <div
                      v-if="activeMode == 'checkbox' && activeQuestion == index"
                      class="answer-wrapper"
                    >
                      <div class="answer answer3">{{ index + 1 }}</div>
                    </div>
                    <div v-else class="answer-wrapper">
                      <div v-if="item.checked == 0" class="answer answer1">
                        {{ index + 1 }}
                      </div>
                      <div v-if="item.checked == 2" class="answer answer2">
                        {{ index + 1 }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="content-answer-card-item" style="margin-top: 28px">
                <div class="exercise-title">
                  判断题
                  <div class="exercise-right-line"></div>
                </div>
                <div class="exercise-answer-option-wrapper">
                  <div
                    v-if="
                      activePaper == 'partError' ||
                      activePaper == 'partAnalysis' ||
                      activePaper == 'totalError' ||
                      activePaper == 'totalAnalysis'
                    "
                    class="exercise-answer-option-wrapper"
                  >
                    <div
                      v-for="(item, index) in justifyArr"
                      :key="index"
                      class="exercise-answer-option"
                      :style="index % 6 == 5 ? 'margin-right:0px;' : ''"
                      @click="handleQuestion(item, index)"
                    >
                      <div v-if="item.userAnswer" class="answer-wrapper">
                        <div
                          v-if="item.isRight == 0"
                          class="answer answer-error"
                        >
                          {{ index + 1 }}
                        </div>
                        <div v-else class="answer answer-right">
                          {{ index + 1 }}
                        </div>
                      </div>
                      <div v-else class="answer-wrapper">
                        <div class="answer answer-no">{{ index + 1 }}</div>
                      </div>
                    </div>
                  </div>
                  <div v-else class="exercise-answer-option-wrapper">
                    <div
                      v-for="(item, index) in justifyArr"
                      :key="index"
                      class="exercise-answer-option"
                      :style="index % 6 == 5 ? 'margin-right:0px;' : ''"
                      @click="handleQuestion(item, index)"
                    >
                      <div
                        v-if="
                          activeMode == 'justify' && activeQuestion == index
                        "
                        class="answer-wrapper"
                      >
                        <div class="answer answer3">{{ index + 1 }}</div>
                      </div>
                      <div v-else class="answer-wrapper">
                        <div v-if="item.checked == 0" class="answer answer1">
                          {{ index + 1 }}
                        </div>
                        <div v-if="item.checked == 2" class="answer answer2">
                          {{ index + 1 }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                v-if="
                  activePaper == 'partError' ||
                  activePaper == 'partAnalysis' ||
                  activePaper == 'totalError' ||
                  activePaper == 'totalAnalysis'
                "
                class="exercise-answer-info-wrapper"
              >
                <div class="exercise-answer-info">
                  <div class="exercise-answer-info-circle circle-right"></div>
                  <div class="exercise-answer-info-label">正确</div>
                </div>
                <div class="exercise-answer-info">
                  <div
                    class="exercise-answer-info-circle circle-error circle-gap"
                  ></div>
                  <div class="exercise-answer-info-label">错误</div>
                </div>
                <div class="exercise-answer-info">
                  <div
                    class="exercise-answer-info-circle circle3 circle-gap"
                  ></div>
                  <div class="exercise-answer-info-label">未选</div>
                </div>
              </div>
              <div v-else class="exercise-answer-info-wrapper">
                <div class="exercise-answer-info">
                  <div class="exercise-answer-info-circle circle1"></div>
                  <div class="exercise-answer-info-label">已选</div>
                </div>
                <div class="exercise-answer-info">
                  <div
                    class="exercise-answer-info-circle circle2 circle-gap"
                  ></div>
                  <div class="exercise-answer-info-label">当前</div>
                </div>
                <div class="exercise-answer-info">
                  <div
                    class="exercise-answer-info-circle circle3 circle-gap"
                  ></div>
                  <div class="exercise-answer-info-label">未选</div>
                </div>
              </div>
              <div
                v-if="
                  (activePaper == 'partEdit' || activePaper == 'totalEdit') &&
                  intoExerciseType !== 'viewExercise'
                "
                class="exercise-submit-btn"
                @click="submitExercise"
              >
                交卷
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title=""
      :show-close="true"
      width="524px"
      :visible.sync="tipsDialog"
      class="dialog-container"
    >
      <div class="dialog-header">
        <div>温馨提示</div>
      </div>
      <div class="dialog-content">
        <div class="dialog-info">
          本次测试中您还有{{ hasNotAnswer }}题未作答，是否确认提交？
        </div>
        <div class="dialog-btn-wrapper">
          <el-button @click="keepAnswer">继续作答</el-button>
          <el-button type="primary" @click="forceSubmitExercise"
            >确认交卷</el-button
          >
        </div>
      </div>
    </el-dialog>

    <el-dialog
      title=""
      :show-close="false"
      width="542px"
      :visible.sync="forceSubmitDialog"
      class="dialog-container"
    >
      <div class="dialog-header">
        <div>温馨提示</div>
      </div>
      <div class="dialog-content">
        <div class="dialog-info">
          <div class="dialog-info-label">答题时间已结束，请您提交试卷</div>
        </div>
        <div class="dialog-btn-wrapper" style="justify-content: center">
          <div class="dialog-btn dialog-deal-btn" @click="forceSubmitExercise">
            提交
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import {
  partTestQuestionPaper,
  submitQuestion,
  submitExam,
  updateExamTime,
  examAnalysis,
  totalTestQuestionList,
  examTotalTestQuestion,
  updateTotalTestExamTime,
  submitTotalTest,
  totalExamAnalysis,
} from "@/api/index.js";
export default {
  name: "",
  components: {
    Header,
  },
  data() {
    return {
      dept: "",
      token: "",
      metaExamId: "",
      exerciseData: {},
      planId: "",
      activePaper: "partEdit",
      intoExerciseType: "enterExercise", // viewExercise查看试卷  enterExercise进行考试
      partExamInfo: {
        // 测试基本信息
        uncommittedUserExamId: null,
      },
      activeMode: "radio",
      form: {},
      analysisType: 1,
      parseShow: false,
      correctAnswerShow: false,
      examTime: "",
      timeCountSum: 0,
      radioArr: [],
      checkboxArr: [],
      justifyArr: [],
      activeQuestion: 0,
      hasNotAnswer: 0,
      tipsDialog: false,
      userExamId: "",
      userId: "",
      forceSubmitDialog: false,
    };
  },
  mounted() {
    this.dept = window.localStorage.getItem("dept");
    this.token = window.localStorage.getItem("token");
    this.planId = this.$route.params.planId;
    this.metaExamId = this.$route.params.examId;
    var exerciseData = JSON.parse(window.localStorage.getItem("exercise"));
    this.exerciseData = exerciseData;
    var activePaper = exerciseData.mode;
    this.activePaper = activePaper;
    this.intoExerciseType = exerciseData.intoExerciseType;
    if (this.intoExerciseType !== "viewExercise") {
      // 如果不是查看试卷
      this.partExamInfo = exerciseData.partExamInfo;
    }
    switch (activePaper) {
      case "partEdit":
        this.getExercisePaper();
        break;
      case "partDetail":
        this.getExercisePaper();
        break;
      case "partError":
        this.analysisType = 2;
        this.getExamAnalysis();
        break;
      case "partAnalysis":
        this.analysisType = 1;
        this.getExamAnalysis();
        this.correctAnswerShow = true;
        this.parseShow = true;
        break;
      case "totalEdit":
        this.getExamPaper();
        break;
      case "totalDetail":
        this.getExamPaper();
        break;
      case "totalError":
        this.analysisType = 2;
        this.getExamPaperAnalysis();
        break;
      case "totalAnalysis":
        this.analysisType = 1;
        this.getExamPaperAnalysis();
        this.correctAnswerShow = true;
        this.parseShow = true;
        break;
    }
  },
  beforeDestroy() {
    if (this.activePaper == "partEdit") {
      this.resetExamTime();
    }
    if (this.activePaper == "totalEdit") {
      this.resetTotalTestExamTime();
    }
  },
  methods: {
    handleBack() {
      if (this.activePaper == "partEdit") {
        this.resetExamTime();
      }
      if (this.activePaper == "totalEdit") {
        this.resetTotalTestExamTime();
      }
      this.$router.push(`/planDetail/edit/${this.planId}`);
    },
    getExercisePaper() {
      partTestQuestionPaper(
        {
          deptId: this.dept,
          metaExamId: this.metaExamId,
          planId: this.planId,
          userExamId:
            this.partExamInfo && this.partExamInfo.uncommittedUserExamId
              ? this.partExamInfo.uncommittedUserExamId
              : null,
          userId: 0,
        },
        {
          Authorization: this.token,
          DeptId: this.dept,
        }
      )
        .then((res) => {
          if (res.code == 200) {
            var data = res.data;
            var timeCount = data.examTime;
            this.timeCountSum = timeCount;
            this.examTime = this.resetTimes(timeCount);
            var _this = this;
            if (this.activePaper == "partEdit") {
              var timeClock = setInterval(function () {
                if (timeCount > 0) {
                  timeCount--;
                  _this.timeCountSum = timeCount;
                  _this.examTime = _this.resetTimes(timeCount);
                } else {
                  _this.timeCountSum = 0;
                  clearInterval(timeClock);
                  _this.forceSubmitDialog = true;
                }
              }, 1000);
            }
            var questionArr = data.questionMap;
            // lastUserQuestionType 未交卷时当前填写的类型 lastUserQuestionId 未交卷时当前填写的题目
            this.resetQuestion(
              questionArr,
              data.lastUserQuestionType,
              data.lastUserQuestionId
            );
          }
          return;
        })
        .catch((err) => {
         // console.log(err);
        });
    },
    getExamPaper() {
      totalTestQuestionList(
        {
          deptId: this.dept,
          metaExamId: this.metaExamId,
          planId: this.planId,
          userExamId:
            this.partExamInfo && this.partExamInfo.uncommittedUserExamId
              ? this.partExamInfo.uncommittedUserExamId
              : null,
          userId: 0,
        },
        {
          Authorization: this.token,
          DeptId: this.dept,
        }
      )
        .then((res) => {
          if (res.code == 200) {
            var data = res.data;
            var timeCount = data.examTime;
            this.timeCountSum = timeCount;
            this.examTime = this.resetTimes(timeCount);
            var _this = this;
            if (this.activePaper == "totalEdit") {
              var timeClock = setInterval(function () {
                if (timeCount > 0) {
                  timeCount--;
                  _this.timeCountSum = timeCount;
                  _this.examTime = _this.resetTimes(timeCount);
                } else {
                  _this.timeCountSum = 0;
                  clearInterval(timeClock);
                  _this.forceSubmitDialog = true;
                }
              }, 1000);
            }
            var questionArr = data.questionMap;
            // // lastUserQuestionType 未交卷时当前填写的类型 lastUserQuestionId 未交卷时当前填写的题目
            this.resetQuestion(
              questionArr,
              data.lastUserQuestionType,
              data.lastUserQuestionId
            );
          }
          return;
        })
        .catch((err) => {
         // console.log(err);
        });
    },
    resetQuestion(data, lastUserQuestionType, lastUserQuestionId) {
      var radioArr = data.single;
      var checkboxArr = data.multiple;
      var justifyArr = data.judgment;
      var newRadioArr = [];
      var lastUserQuestionIndex = 0; // 当前选中的题目
      if (lastUserQuestionType && lastUserQuestionId) {
        switch (lastUserQuestionType) {
          case 1: // 单选
            this.activeMode = "radio";
            if (radioArr && radioArr.length !== 0) {
              lastUserQuestionIndex = radioArr.findIndex(
                (item) => item.userQuestionId === lastUserQuestionId
              );
            }
            if (
              lastUserQuestionIndex > -1 &&
              lastUserQuestionIndex !== radioArr.length - 1
            ) {
              lastUserQuestionIndex += 1;
            } else if (
              lastUserQuestionIndex > -1 &&
              lastUserQuestionIndex === radioArr.length - 1
            ) {
              // 如果是放前类型的最后一个
              this.activeMode = "checkbox"; // checkbox \justify
              lastUserQuestionIndex = 0;
            }
            break;
          case 2: // 多选
            this.activeMode = "checkbox";
            if (checkboxArr && checkboxArr.length !== 0) {
              lastUserQuestionIndex = checkboxArr.findIndex(
                (item) => item.userQuestionId === lastUserQuestionId
              );
            }
            if (
              lastUserQuestionIndex > -1 &&
              lastUserQuestionIndex !== radioArr.length - 1
            ) {
              lastUserQuestionIndex += 1;
            } else if (
              lastUserQuestionIndex > -1 &&
              lastUserQuestionIndex === radioArr.length - 1
            ) {
              // 如果是放前类型的最后一个
              this.activeMode = "justify"; // checkbox \justify
              lastUserQuestionIndex = 0;
            }
            break;
          case 3: // 判断
            this.activeMode = "justify";
            if (justifyArr && justifyArr.length !== 0) {
              lastUserQuestionIndex = justifyArr.findIndex(
                (item) => item.userQuestionId === lastUserQuestionId
              );
            }
            if (
              lastUserQuestionIndex > -1 &&
              lastUserQuestionIndex !== radioArr.length - 1
            ) {
              lastUserQuestionIndex += 1;
            }
            break;

          default:
            break;
        }
      }
      for (var i = 0; i < radioArr.length; i++) {
        var itemRadio = radioArr[i];
        if (i == 0) {
          this.userExamId = itemRadio.userExamId;
          this.userId = itemRadio.userId;
          this.form = itemRadio;
        }
        itemRadio["options"] = JSON.parse(itemRadio.questionOptions);
        itemRadio["checked"] = 0;
        itemRadio["answerVal"] = itemRadio.userAnswer || "";
        newRadioArr.push(itemRadio);
        if (i == radioArr.length - 1) {
          this.radioArr = newRadioArr;
        }
      }
      var newCheckboxArr = [];
      for (var j = 0; j < checkboxArr.length; j++) {
        var itemCheckbox = checkboxArr[j];
        itemCheckbox["options"] = JSON.parse(itemCheckbox.questionOptions);
        itemCheckbox["checked"] = 0;
        itemCheckbox["answerVal"] =
          (itemCheckbox.userAnswer && itemCheckbox.userAnswer.split("")) || [];
        if (
          this.activePaper == "partError" ||
          this.activePaper == "partAnalysis"
        ) {
          itemCheckbox["answerVal"] = itemCheckbox.userAnswer
            ? itemCheckbox.userAnswer.split("")
            : [];
        }
        newCheckboxArr.push(itemCheckbox);
        if (j == checkboxArr.length - 1) {
          this.checkboxArr = newCheckboxArr;
        }
      }
      var newJustifyArr = [];
      for (var k = 0; k < justifyArr.length; k++) {
        var itemJustify = justifyArr[k];
        itemJustify["options"] = JSON.parse(itemJustify.questionOptions);
        itemJustify["checked"] = 0;
        itemJustify["answerVal"] = itemJustify.userAnswer || "";
        newJustifyArr.push(itemJustify);
        if (k == justifyArr.length - 1) {
          this.justifyArr = newJustifyArr;
        }
      }
      // 判断当前是进行到哪个题目
      if (lastUserQuestionType && lastUserQuestionId) {
        this.activeQuestion = lastUserQuestionIndex;
        this.$nextTick(() => {
          this.reViewQuestion();
        });
      }
    },
    getExamAnalysis() {
      var scoreData = JSON.parse(window.localStorage.getItem("score"));
      examAnalysis(
        {
          type: this.analysisType,
          userExamId: scoreData.userExamId,
          userId: 0,
        },
        {
          Authorization: this.token,
          DeptId: this.dept,
        }
      )
        .then((res) => {
          if (res.code == 200) {
            var data = res.data;
            var timeCount = data.examTime;
            this.examTime = this.resetTimes(timeCount);
            var questionArr = data.questionMap;
            this.resetQuestion(questionArr);
          }
          return;
        })
        .catch((err) => {
         // console.log(err);
        });
    },
    getExamPaperAnalysis() {
      var scoreData = JSON.parse(window.localStorage.getItem("score"));
      totalExamAnalysis(
        {
          type: this.analysisType,
          userExamId: scoreData.userExamId,
          userId: 0,
        },
        {
          Authorization: this.token,
          DeptId: this.dept,
        }
      )
        .then((res) => {
          if (res.code == 200) {
            var data = res.data;
            var timeCount = data.examTime;
            this.examTime = this.resetTimes(timeCount);
            var questionArr = data.questionMap;
            this.resetQuestion(questionArr);
          }
          return;
        })
        .catch((err) => {
         // console.log(err);
        });
    },
    viewLastQuestion() {
      var mode = this.activeMode;
      var index = this.activeQuestion;
      switch (mode) {
        case "radio":
          if (index == 0) {
            this.$message({
              message: "当前试题为测试第一题",
              type: "warning",
            });
          } else {
            this.activeQuestion = index - 1;
          }
          this.reViewQuestion();
          break;
        case "checkbox":
          if (index == 0) {
            this.activeMode = "radio";
            this.activeQuestion = this.radioArr.length - 1;
          } else {
            this.activeQuestion = index - 1;
          }
          this.reViewQuestion();
          break;
        case "justify":
          if (index == 0) {
            this.activeMode = "checkbox";
            this.activeQuestion = this.checkboxArr.length - 1;
          } else {
            this.activeQuestion = index - 1;
          }
          this.reViewQuestion();
          break;
      }
    },
    viewNextQuestion() {
      var mode = this.activeMode;
      var index = this.activeQuestion;
      var totalNum =
        this.radioArr.length + this.checkboxArr.length + this.justifyArr.length;
      switch (mode) {
        case "radio":
          if (this.radioArr.length > 0) {
            if (index == this.radioArr.length - 1) {
              if (index == totalNum - 1) {
                this.$message({
                  message: "当前试题为测试最后一题",
                  type: "warning",
                });
              } else {
                if (this.checkboxArr.length > 0) {
                  this.activeMode = "checkbox";
                  this.activeQuestion = 0;
                } else {
                  this.$message({
                    message: "当前试题为测试最后一题",
                    type: "warning",
                  });
                }
              }
            } else {
              this.activeQuestion = index + 1;
            }
            this.reViewQuestion();
          }
          break;
        case "checkbox":
          if (this.checkboxArr.length > 0) {
            if (index == this.checkboxArr.length - 1) {
              if (index == totalNum - 1) {
                this.$message({
                  message: "当前试题为测试最后一题",
                  type: "warning",
                });
              } else {
                if (this.justifyArr.length > 0) {
                  this.activeMode = "justify";
                  this.activeQuestion = 0;
                } else {
                  this.$message({
                    message: "当前试题为测试最后一题",
                    type: "warning",
                  });
                }
              }
            } else {
              this.activeQuestion = index + 1;
            }
            this.reViewQuestion();
          }
          break;
        case "justify":
          if (this.justifyArr.length > 0) {
            if (index == this.justifyArr.length - 1) {
              this.$message({
                message: "当前试题为测试最后一题",
                type: "warning",
              });
            } else {
              this.activeQuestion = index + 1;
            }
            this.reViewQuestion();
          }
          break;
      }
    },
    reViewQuestion() {
      var mode = this.activeMode;
      var index = this.activeQuestion;
      var dataArr = [];
      switch (mode) {
        case "radio":
          dataArr = this.radioArr;
          break;
        case "checkbox":
          dataArr = this.checkboxArr;
          break;
        case "justify":
          dataArr = this.justifyArr;
          break;
      }
      // 避免最后一题返回再进来index和数组长度相同报错
      if (dataArr.length === this.activeQuestion) {
        index = this.activeQuestion - 1;
      }
      if (dataArr.length > 0) {
        var activeRow = dataArr[index];
        this.handleQuestion(activeRow, index);
      }
    },
    answerQuestion() {
      var mode = this.activeMode;
      var index = this.activeQuestion;
      var form = this.form;
      var answer = form.answerVal;
      switch (mode) {
        case "radio":
          this.radioArr[index]["answerVal"] = answer;
          break;
        case "checkbox":
          this.checkboxArr[index]["answerVal"] = answer;
          break;
        case "justify":
          this.justifyArr[index]["answerVal"] = answer;
          break;
      }
      if (this.activePaper == "partEdit") {
        this.requestQuestion(form);
      }
      if (this.activePaper == "totalEdit") {
        this.requestTotalTestQuestion(form);
      }
    },
    requestQuestion(form) {
      var answerVal = form.answerVal;
      if (form.questionType == 2) {
        answerVal = answerVal.join("");
      }
      submitQuestion(
        {
          userAnswer: answerVal,
          userId: 0,
          userQuestionId: form.userQuestionId,
        },
        {
          Authorization: this.token,
          DeptId: this.dept,
        }
      )
        .then((res) => {
          if (res.code == 200) {
            //答题成功
            this.resetExamTime();
          }
          return;
        })
        .catch((err) => {
         // console.log(err);
        });
    },
    requestTotalTestQuestion(form) {
      var answerVal = form.answerVal;
      if (form.questionType == 2) {
        answerVal = answerVal.join("");
      }
      examTotalTestQuestion(
        {
          userAnswer: answerVal,
          userId: 0,
          userQuestionId: form.userQuestionId,
        },
        {
          Authorization: this.token,
          DeptId: this.dept,
        }
      )
        .then((res) => {
          if (res.code == 200) {
            //答题成功
            this.resetTotalTestExamTime();
          }
          return;
        })
        .catch((err) => {
         // console.log(err);
        });
    },
    resetExamTime() {
      updateExamTime(
        {
          examTime: this.timeCountSum,
          userExamId: this.userExamId,
          userId: 0,
        },
        {
          Authorization: this.token,
          DeptId: this.dept,
        }
      )
        .then((res) => {
          if (res.code == 200) {
            //提交时间
          }
          return;
        })
        .catch((err) => {
         // console.log(err);
        });
    },
    resetTotalTestExamTime() {
      updateTotalTestExamTime(
        {
          examTime: this.timeCountSum,
          userExamId: this.userExamId,
          userId: 0,
        },
        {
          Authorization: this.token,
          DeptId: this.dept,
        }
      )
        .then((res) => {
          if (res.code == 200) {
            //更新时间
          }
          return;
        })
        .catch((err) => {
         // console.log(err);
        });
    },
    handleQuestion(row, index) {
      this.activeQuestion = index;
      var modeVal = row.questionType;
      switch (modeVal) {
        case 1:
          this.activeMode = "radio";
          break;
        case 2:
          this.activeMode = "checkbox";
          break;
        case 3:
          this.activeMode = "justify";
          break;
      }
      this.form = row;
      this.resetEditStatus();
    },
    resetEditStatus() {
      var mode = this.activeMode;
      var activeIndex = this.activeQuestion;
      var radioArr = this.radioArr;
      this.radioArr = radioArr.map(function (item, index) {
        if (item.answerVal && item.answerVal != "") {
          item["checked"] = 2;
        }
        return item;
      });
      var checkboxArr = this.checkboxArr;
      this.checkboxArr = checkboxArr.map(function (item, index) {
        if (item.answerVal && item.answerVal.length > 0) {
          item["checked"] = 2;
        }
        return item;
      });
      var justifyArr = this.justifyArr;
      this.justifyArr = justifyArr.map(function (item, index) {
        if (item.answerVal && item.answerVal != "") {
          item["checked"] = 2;
        }
        return item;
      });
    },
    resetTimes(time) {
      var hours = parseInt(time / 3600);
      var hoursRum = time % 3600;
      var minutes = parseInt(hoursRum / 60);
      var seconds = hoursRum % 60;
      if (hours < 10) {
        hours = "0" + hours;
      }
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      if (seconds < 10) {
        seconds = "0" + seconds;
      }
      return `${hours}:${minutes}:${seconds}`;
    },
    viewParse() {
      this.parseShow = !this.parseShow;
    },
    submitExercise() {
      var radioArr = this.radioArr;
      var checkboxArr = this.checkboxArr;
      var justifyArr = this.justifyArr;
      var totalArr = radioArr.concat(checkboxArr);
      totalArr = totalArr.concat(justifyArr);
      var sum = totalArr.length;
      var num = 0;
      for (var i = 0; i < sum; i++) {
        var item = totalArr[i];
        if (item.answerVal != "") {
          num++;
        }
        if (i == sum - 1) {
          if (num < sum) {
            this.hasNotAnswer = sum - num;
            this.tipsDialog = true;
            return false;
          }
          if (this.activePaper == "partEdit") {
            this.requestSubmitExam();
          }
          if (this.activePaper == "totalEdit") {
            this.requestTotalTestExam();
          }
        }
      }
    },
    forceSubmitExercise() {
      if (this.activePaper == "partEdit") {
        this.requestSubmitExam();
      }
      if (this.activePaper == "totalEdit") {
        this.requestTotalTestExam();
      }
    },
    keepAnswer() {
      this.tipsDialog = false;
    },
    requestSubmitExam() {
      submitExam(
        {
          examTime: this.timeCountSum,
          userExamId: this.userExamId,
          userId: 0,
        },
        {
          Authorization: this.token,
          DeptId: this.dept,
        }
      )
        .then((res) => {
          if (res.code == 200) {
            this.resetExamTime();
            var data = res.data;
            data["palnId"] = this.planId;
            data["title"] = this.exerciseData.title;
            window.localStorage.setItem("score", JSON.stringify(data));
            // 交卷后删除partExamInfo 用来判断没交卷时回显当前选中的，避免交卷后重新测试传参问题
            var exerciseData = JSON.parse(
              window.localStorage.getItem("exercise")
            );
            if (exerciseData.partExamInfo) {
              delete exerciseData.partExamInfo;
            }
            window.localStorage.setItem(
              "exercise",
              JSON.stringify(exerciseData)
            );
            this.$router.push(`/exerciseScore`);
          }
          return;
        })
        .catch((err) => {
         // console.log(err);
        });
    },
    requestTotalTestExam() {
      submitTotalTest(
        {
          examTime: this.timeCountSum,
          userExamId: this.userExamId,
          userId: 0,
        },
        {
          Authorization: this.token,
          DeptId: this.dept,
        }
      )
        .then((res) => {
          if (res.code == 200) {
            var _this = this;
            this.resetTotalTestExamTime();
            var data = res.data;
            data["palnId"] = this.planId;
            data["title"] = this.exerciseData.title;
            window.localStorage.setItem("score", JSON.stringify(data));
            // 交卷后删除partExamInfo 用来判断没交卷时回显当前选中的，避免交卷后重新测试传参问题
            var exerciseData = JSON.parse(
              window.localStorage.getItem("exercise")
            );
            if (exerciseData.partExamInfo) {
              delete exerciseData.partExamInfo;
            }
            window.localStorage.setItem(
              "exercise",
              JSON.stringify(exerciseData)
            );
            this.$router.push(`/exerciseScore`);
          }
          return;
        })
        .catch((err) => {
         // console.log(err);
        });
    },
  },
};
</script>

<style scoped>
.page-container {
  width: 100%;
  margin: 0 auto;
}
.page-wrapper {
  width: 1200px;
  margin: 0 auto;
  padding: 100px;
}
.page-back-wrapper {
  width: 100%;
  height: 68px;
  background: #ffffff;
  box-shadow: 0px 5px 20px 0px rgba(149, 154, 170, 0.15);
  border-radius: 8px;
  border: 1px solid #f0f0f3;
  display: flex;
  align-items: center;
  margin-top: 18px;
}
.page-back-img {
  width: 20px;
  height: 20px;
  margin-right: 8px;
  display: inline-block;
  position: relative;
  top: 2px;
}
.page-back {
  display: flex;
  align-items: center;
  margin-left: 30px;
  cursor: pointer;
}
.page-title {
  font-size: 22px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #666666;
  margin-left: 30px;
}
.content-container {
  display: flex;
  width: 100%;
  margin-top: 18px;
}
.content-left-container {
  flex: 1;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #eaeaea;
  display: flex;
}
.content-right-container {
  width: 452px;
  margin-left: 18px;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #eaeaea;
  display: flex;
  flex: 0 0 auto;
}
.content-left-wrapper {
  flex: 1;
  margin: 24px 40px 120px 40px;
}
.content-right-wrapper {
  flex: 1;
  margin: 24px 30px 120px 30px;
}
.content-left-title {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #666666;
}
.clock-img {
  width: 28px;
  height: 28px;
  margin-right: 12px;
}
.exercise-title {
  font-size: 24px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #3e63ee;
  position: relative;
  margin-top: 13px;
}
.exercise-left-line {
  width: 6px;
  height: 24px;
  background: #3e63ee;
  border-radius: 3px;
  position: absolute;
  left: -40px;
  top: 5px;
}
.exercise-right-line {
  width: 6px;
  height: 24px;
  background: #3e63ee;
  border-radius: 3px;
  position: absolute;
  left: -30px;
  top: 5px;
}
.exercise-content-title {
  font-size: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  margin-top: 30px;
}
.exercise-options-wrapper {
  margin-top: 30px;
  min-height: 160px;
}
.exercise-options-wrapper >>> .el-radio__label {
  font-size: 20px !important;
  font-family: PingFangSC-Regular, PingFang SC !important;
  font-weight: 400 !important;
  color: #333333 !important;
}
.exercise-options-wrapper >>> .el-radio__inner {
  position: relative;
  top: -2px;
}
.exercise-options-wrapper >>> .el-checkbox__label {
  font-size: 19px !important;
  font-family: PingFangSC-Regular, PingFang SC !important;
  font-weight: 400 !important;
  color: #333333 !important;
}
.exercise-options-wrapper >>> .el-checkbox__inner {
  position: relative;
  top: -2px;
}
.exercise-options-wrapper >>> .el-checkbox__original {
  text-align: center !important;
}

.exercise-content-item {
  margin-bottom: 14px;
  display: flex;
  align-items: center;
}
.exercise-answer-container {
  margin-top: 96px;
  min-height: 200px;
}
.exercise-btn-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 45px;
}
.exercise-btn {
  width: 108px;
  height: 40px;
  background: #3e63ee;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  transition: 0.5s;
  transition-property: all;
  transition-duration: 0.5s;
  transition-timing-function: ease;
  transition-delay: 0s;
}
.exercise-btn:hover {
  cursor: pointer;
  opacity: 0.8;
}
.exercise-answer-option-wrapper {
  display: flex;
  flex-wrap: wrap;
}
.exercise-answer-option {
  width: 32px;
  height: 32px;
  margin-top: 15px;
  margin-right: 35px;
}
.answer-wrapper {
  width: 100%;
  height: 100%;
}
.answer {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  border-radius: 50%;
  transition: 0.5s;
  transition-property: all;
  transition-duration: 0.5s;
  transition-timing-function: ease;
  transition-delay: 0s;
}
.answer:hover {
  cursor: pointer;
  opacity: 0.8;
}
.answer1 {
  color: #333333;
  border: solid #eaeaea 1px;
}
.answer2 {
  color: #fff;
  background: #ff9645;
  border: solid #ff9645 1px;
}
.answer3 {
  color: #fff;
  background: #4f79ed;
  border: solid #4f79ed 1px;
}
.answer-error {
  color: #fff;
  background: #eb6c48;
  border: solid #eb6c48 1px;
}
.answer-right {
  color: #fff;
  background: #28bebe;
  border: solid #28bebe 1px;
}
.answer-no {
  color: #333333;
  border: solid #eaeaea 1px;
}
.exercise-answer-info-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 36px;
  margin-top: 37px;
  border-top: 1px solid #eaeaea;
}
.exercise-answer-info-circle {
  width: 17px;
  height: 17px;
  border-radius: 50%;
}
.circle1 {
  background: #ff9645;
  border: solid #ff9645 1px;
}
.circle2 {
  background: #4f79ed;
  border: solid #4f79ed 1px;
}
.circle3 {
  border: 1px solid #eaeaea;
}
.circle-right {
  background: #28bebe;
  border: solid #28bebe 1px;
}
.circle-error {
  background: #eb6c48;
  border: solid #eb6c48 1px;
}
.exercise-answer-info-label {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  margin-left: 5px;
}
.exercise-answer-info {
  display: flex;
  align-items: center;
}
.circle-gap {
  margin-left: 50px;
}
.exercise-submit-btn {
  height: 40px;
  background: #3e63ee;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  margin-top: 50px;
  transition: 0.5s;
  transition-property: all;
  transition-duration: 0.5s;
  transition-timing-function: ease;
  transition-delay: 0s;
}
.exercise-submit-btn:hover {
  cursor: pointer;
  opacity: 0.8;
}
.exercise-answer-isRight-btn {
  width: 134px;
  height: 40px;
  background: #28bebe;
  border-radius: 8px 8px 0px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
}
.exercise-answer-isError-btn {
  width: 134px;
  height: 40px;
  background: #eb6c48;
  border-radius: 8px 8px 0px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
}
.right-img {
  width: 20px;
  height: 15px;
  margin-left: 14px;
}
.exercise-answer-isError-icon {
  display: inline-block;
  font-size: 22px;
  font-weight: 600;
  position: relative;
  left: 10px;
  top: 1px;
}
.exercise-answer-content {
  height: 110px;
  background: rgb(248, 248, 248);
  border-radius: 0px 8px 8px 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.exercise-answer-content-left {
  display: flex;
  align-items: center;
}
.exercise-answer-content-right {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #303b45;
  margin-right: 18px;
}
.parse1-img {
  width: 24px;
  height: 27px;
  margin-right: 11px;
}
.exercise-answer-content-right:hover {
  cursor: pointer;
  opacity: 0.8;
}
.exercise-answer-content-right-answer-label {
  font-size: 20px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #303b45;
}
.exercise-answer-content-right-answer-value {
  font-size: 24px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #28bebe;
  margin-top: 6px;
}
.right-answer {
  margin-left: 18px;
  margin-right: 30px;
}
.my-answer {
  margin-left: 30px;
}
.answer-line {
  width: 1px;
  height: 47px;
  background: #e1e1e1;
}
.exercise-parse-container {
  background: #ffffff;
  border-radius: 14px;
  border: 1px solid #cbcbcb;
  margin-top: 20px;
}
.exercise-parse-header {
  display: flex;
  align-items: center;
  font-size: 22px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #666666;
  margin: 20px 0px 13px 17px;
}
.exercise-parse-content-wrapper {
  display: flex;
}
.exercise-parse-content {
  flex: 1;
  margin: 0px 26px 25px 18px;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
}
.dialog-container >>> .el-dialog__body {
  padding: 0px !important;
}
.dialog-container >>> .el-dialog__header {
  padding: 0px !important;
}
.dialog-header {
  width: 100%;
  height: 59px;
  background: #f8faff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
}
.dialog-content {
  padding: 46px 77px 60px 77px;
}
.dialog-btn-wrapper {
  display: flex;
  justify-content: space-between;
  margin-top: 50px;
}
.dialog-content >>> .el-button {
  width: 148px !important;
  height: 40px !important;
  line-height: 40px !important;
  border-radius: 6px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  font-size: 18px !important;
  font-family: PingFangSC-Regular, PingFang SC !important;
}
.dialog-content >>> .el-button--primary {
  background: linear-gradient(90deg, #5580f5 0%, #72a3f5 100%) !important;
}
.dialog-content >>> .el-button--default {
  border: 1px solid #4f79ed;
  color: #4f79ed !important;
}
.answerShow-border {
  width: 20px;
  height: 20px;
  border: solid #666666 1px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 3px;
  position: relative;
  top: 1px;
}
.answerShow-border-right {
  width: 20px;
  height: 20px;
  border: solid #28bebe 1px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 3px;
  position: relative;
  top: 1px;
  color: #28bebe;
}
.answerShow-border-error {
  width: 20px;
  height: 20px;
  border: solid #eb6c48 1px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 3px;
  position: relative;
  top: 1px;
  color: #eb6c48;
}
.answerShow-container {
  display: flex;
  align-items: center;
}
.answerShow-radio {
  border-radius: 50%;
}
.answerShow-item-icon {
  font-size: 14px;
}
.answerShow-item-label {
  font-size: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  margin-left: 15px;
}
.answerShow-item-label-right {
  font-size: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #28bebe;
  margin-left: 15px;
}
.exercise-options-wrapper .answer-value-wrap {
  margin-right: 15px;
}
.exercise-options-wrapper .answer-lable-wrap {
  display: inline-grid;
  white-space: pre-line;
  word-wrap: break-word;
  margin-right: 8px;
}
.answerShow-item-label-error {
  font-size: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #eb6c48;
  margin-left: 15px;
}
.dialog-btn {
  width: 140px;
  height: 38px;
  border-radius: 6px;
  border: 1px solid #3e63ee;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.5s;
  transition-property: all;
  transition-duration: 0.5s;
  transition-timing-function: ease;
  transition-delay: 0s;
}
.dialog-deal-btn {
  background: #3e63ee;
  color: #fff;
}
.dialog-deal-btn:hover {
  cursor: pointer;
  opacity: 0.8;
}
.dialog-info-label {
  font-size: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  text-align: center;
}
</style>


